import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const TrashSolidIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.14708 1.97966C9.55511 1.36762 10.242 1 10.9776 1H13.0228C13.7584 1 14.4453 1.36762 14.8533 1.97966L15.8502 3.475H19.9752C20.4308 3.475 20.8002 3.84436 20.8002 4.3C20.8002 4.75563 20.4308 5.12499 19.9752 5.12499H4.02519C3.56956 5.12499 3.2002 4.75563 3.2002 4.3C3.2002 3.84436 3.56956 3.475 4.02519 3.475H8.15019L9.14708 1.97966ZM15.3002 23H8.70025C6.2702 23 4.30025 21.03 4.30025 18.6V6.49998H19.7002V18.6C19.7002 21.03 17.7303 23 15.3002 23ZM9.80025 10.075C10.2559 10.075 10.6252 10.4443 10.6252 10.9V18.6C10.6252 19.0556 10.2559 19.425 9.80025 19.425C9.34461 19.425 8.97525 19.0556 8.97525 18.6L8.97525 10.9C8.97525 10.4443 9.34461 10.075 9.80025 10.075ZM14.2002 10.075C14.6559 10.075 15.0252 10.4443 15.0252 10.9V18.6C15.0252 19.0556 14.6559 19.425 14.2002 19.425C13.7446 19.425 13.3752 19.0556 13.3752 18.6V10.9C13.3752 10.4443 13.7446 10.075 14.2002 10.075Z"
      fill={props.color}
    />
  </svg>
)
